export default __webpack_public_path__ + "static/media/preview_icon.25e998b8.svg";